
export default class ConversationBriefingRecapEvent {
    constructor(type) {
        this._type = type;
    }

    get type() {
        return this._type;
    }
}

ConversationBriefingRecapEvent.PERFORM = "ConversationBriefingRecapEvent.PERFORM";